import React, { useEffect } from "react";
import Select from "react-select";

const JobType = ({ selectedValue, setFilter }) => {
    const options = [
        {
            value: 'Operations',
            label: 'Operations'
        },
        {
            value: 'Engineering',
            label: 'Engineering'
        },
        {
            value: 'Management',
            label: 'Management'
        },
        {
            value: 'Supervisory',
            label: 'Supervisory'
        },
        {
            value: 'Maintenance',
            label: 'Maintenance'
        },
        {
            value: 'Sales',
            label: 'Sales'
        },
        {
            value: 'Logistics',
            label: 'Logistics'
        },
        {
            value: 'Design',
            label: 'Design'
        },
    ];

    const colourStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: "transparent",
            border: 0,
            boxShadow: "none",
            padding: "12px 0 12px 40px",
            margin: "-16px -6px 0 -52px",
            borderRadius: "0",
            padding: "18px 5px 30px 40px",
        }),
    };

    // Find the matching option object if selectedValue is passed
    const selectedOption = options.find(
        (opt) => opt.value === selectedValue
    ) || null; // fallback to "Recently Posted"

    return (
        <React.Fragment>
            <Select
                options={options}
                styles={colourStyles}
                className="selectForm__inner"
                data-trigger
                value={selectedOption}  // <-- controlled value
                name="choices-single-categories"
                id="choices-single-categories"
                aria-label="Default select example"
                placeholder="Select job category..."
                onChange={(opt) =>
                    setFilter((prev) => ({ ...prev, jobType: opt?.value || "" }))
                }
            />
        </React.Fragment>
    );
};

export default JobType;
